import Vue from 'vue';
import { apiPath } from '../constants';

const Reviews = Vue.resource(
  `${apiPath}/apps{/packageName}/reviews{/id}{/type}/`,
  {},
  {
    replyToReview: { method: 'POST', params: { type: 'reply' } },
    changeReviewReportStatus: { method: 'PUT', params: { type: 'report' } },
    getRateSummary: { method: 'GET', params: { type: 'summary' } },
  },
);

export default Reviews;
